import type { MealTiersMiniEntity } from '@/features/mealTiers/domain/entities/MealTiersMiniEntity'
import type { FileUploadEntity } from '@/shared/entities/FileUploadEntity'
import type { MealCategoryTranslationEntity } from './MealCategoryTranslationEntity'
import type { ItemMiniEntity } from '@/features/item/domain/entities/ItemMiniEntity'

export class CreateUpdateMealCategoryEntity {
  icon?: FileUploadEntity
  enabled?: boolean
  order?: number | null
  isTierFree?: boolean
  translations?: Array<MealCategoryTranslationEntity>
  mealTiers?: Array<MealTiersMiniEntity> | null
  items?: Array<ItemMiniEntity> | null
  iconUrl?: string
}
